var _circle, _mask, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#F1F1F1",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM1.98401 16C1.98401 23.7408 8.25918 30.016 16 30.016C23.7408 30.016 30.016 23.7408 30.016 16C30.016 8.25918 23.7408 1.98401 16 1.98401C8.25918 1.98401 1.98401 8.25918 1.98401 16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM1.98401 16C1.98401 23.7408 8.25918 30.016 16 30.016C23.7408 30.016 30.016 23.7408 30.016 16C30.016 8.25918 23.7408 1.98401 16 1.98401C8.25918 1.98401 1.98401 8.25918 1.98401 16Z",
    stroke: "#50949E",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 22.6663C19.6825 22.6663 22.6673 19.6816 22.6673 15.9997C22.6673 12.3178 19.6825 9.33301 16.0007 9.33301C12.3188 9.33301 9.33398 12.3178 9.33398 15.9997C9.33398 19.6816 12.3188 22.6663 16.0007 22.6663Z",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6667V16",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.333H16.007",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails3);
export default __webpack_public_path__ + "static/media/details3.deab77b0723a515a9241a88d14518863.svg";
export { ForwardRef as ReactComponent };